module.exports = __webpack_public_path__ + "static/media/dot net.1d1f1723.png";